export const setJSONREQUESTOBJECT = "setJSONREQUESTOBJECT";

export const resetJSONREQUESTOBJECT = "resetJSONREQUESTOBJECT";
